"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var SupplierAgreement_1 = require("../model/SupplierAgreement");

var SupplierAgreementUpdateDTO_1 = require("../model/SupplierAgreementUpdateDTO");

var SupplierAgreementUpdateDTOConverter_1 = require("./SupplierAgreementUpdateDTOConverter");

var SupplierAgreementUpdateDTOConverterImpl =
/*#__PURE__*/
function (_SupplierAgreementUpd) {
  _inherits(SupplierAgreementUpdateDTOConverterImpl, _SupplierAgreementUpd);

  function SupplierAgreementUpdateDTOConverterImpl() {
    _classCallCheck(this, SupplierAgreementUpdateDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementUpdateDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierAgreementUpdateDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var schema = SupplierAgreement_1.SupplierAgreement.schema;
      return new SupplierAgreementUpdateDTO_1.SupplierAgreementUpdateDTO(schema.id.valueOf(conversions.documentToClassId(source)), this.valueOrUndefined(source, schema.preferred), this.valueOrUndefined(source, schema.regularPurchasePrice, conversions.toBigNumber), this.valueOrUndefined(source, schema.regularPurchasePriceNett, conversions.toBigNumber), this.valueOrUndefined(source, schema.promoPurchasePrice, conversions.toBigNumber), this.valueOrUndefined(source, schema.promoPurchasePricePlus, conversions.toBigNumber), this.valueOrUndefined(source, schema.promoPurchaseStartDate, conversions.toDate), this.valueOrUndefined(source, schema.promoPurchaseEndDate, conversions.toDate), this.valueOrUndefined(source, schema.purchaseForecastSMPA, conversions.toBigNumber), this.valueOrUndefined(source, schema.confirmedPurchaseForecastSMPA, conversions.toBigNumber), this.valueOrUndefined(source, schema.obligatoryToBuy), this.valueOrUndefined(source, schema.split, conversions.toBigNumber), this.valueOrUndefined(source, schema.promoVolume, conversions.toBigNumber), this.valueOrUndefined(source, schema.minimalVolume, conversions.toBigNumber), this.valueOrUndefined(source, schema.maximalVolume, conversions.toBigNumber), this.valueOrUndefined(source, schema.unitBackDiscount, conversions.toBigNumber), this.valueOrUndefined(source, schema.supplierInvoice, conversions.toClassReferenceId), this.valueOrUndefined(source, schema.unitBackDiscountRealization), this.valueOrUndefined(source, schema.secondaryPlacementFee, conversions.toBigNumber), this.valueOrUndefined(source, schema.leafletFee, conversions.toBigNumber), this.valueOrUndefined(source, schema.warningFlags), this.valueOrUndefined(source, schema.costPriceFormat), this.valueOrUndefined(source, schema.lastPromoPurchaseUpdate, conversions.toDate));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      this.assignIfDefined(result, source, 'preferred');
      this.assignIfDefined(result, source, 'regularPurchasePrice', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'regularPurchasePriceNett', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'promoPurchasePrice', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'promoPurchasePricePlus', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'promoPurchaseStartDate', conversions.fromDate);
      this.assignIfDefined(result, source, 'promoPurchaseEndDate', conversions.fromDate);
      this.assignIfDefined(result, source, 'purchaseForecastSMPA', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'confirmedPurchaseForecastSMPA', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'obligatoryToBuy');
      this.assignIfDefined(result, source, 'split', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'promoVolume', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'minimalVolume', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'maximalVolume', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'unitBackDiscount', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'supplierInvoice', conversions.toDocumentReferenceId);
      this.assignIfDefined(result, source, 'unitBackDiscountRealization');
      this.assignIfDefined(result, source, 'secondaryPlacementFee', conversions.fromBigNumber);
      this.assignIfDefined(result, source, 'leafletFee', conversions.fromBigNumber);

      if (!utils_1.Utils.isUndefined(source.warningFlags)) {
        Object.assign(result, {
          warningFlags: source.warningFlags.serialize()
        });
      }

      this.assignIfDefined(result, source, 'costPriceFormat');
      this.assignIfDefined(result, source, 'lastPromoPurchaseUpdate', conversions.fromDate);
      return result;
    }
  }, {
    key: "valueOrUndefined",
    value: function valueOrUndefined(source, desc, fn) {
      var srcAttr = source[desc.simpleNameKey()];
      return utils_1.Utils.isUndefined(srcAttr) ? undefined : fn ? desc.valueOf(utils_1.Utils.isNull(srcAttr) ? null : fn(srcAttr)) : desc.valueOfField(source);
    }
  }, {
    key: "assignIfDefined",
    value: function assignIfDefined(obj, source, attribute, fn) {
      if (!utils_1.Utils.isUndefined(source[attribute])) {
        var srcObj = {};
        srcObj[attribute] = utils_1.Utils.isNull(source[attribute]) ? null : fn ? fn(source[attribute]) : source[attribute];
        Object.assign(obj, srcObj);
      }
    }
  }]);

  return SupplierAgreementUpdateDTOConverterImpl;
}(SupplierAgreementUpdateDTOConverter_1.SupplierAgreementUpdateDTOConverter);

exports.SupplierAgreementUpdateDTOConverterImpl = SupplierAgreementUpdateDTOConverterImpl;